var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 3.0163C20 2.45769 20.4589 2.00236 21.0139 2.06608C25.6997 2.60406 29.3959 6.30029 29.9339 10.9861C29.9976 11.5411 29.5423 12 28.9837 12H21C20.4477 12 20 11.5523 20 11V3.0163Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3078 3.00011C7.95509 3.10387 2 9.12441 2 16.5001C2 23.94 8.06002 30 15.4999 30C22.8756 30 28.8963 24.0449 28.9999 16.6922C29.0037 16.4181 28.8974 16.1542 28.7053 15.9582C28.5119 15.7635 28.2493 15.6534 27.9751 15.6534H17.3466C16.7944 15.6534 16.3466 15.2056 16.3466 14.6534V4.02487C16.3466 3.75075 16.2365 3.48816 16.0418 3.29472C15.8458 3.10258 15.5819 2.99627 15.3078 3.00011Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.52ca2184c8db228363f2f7d2cbc71824.svg";
export { ForwardRef as ReactComponent };